// extracted by mini-css-extract-plugin
export var actionText = "_kd-4";
export var container = "_kd-0";
export var leftSection = "_kd-1";
export var rightSection = "_kd-2";
export var settingsButton = "_kd-6";
export var settingsIcon = "_kd-7";
export var shortcut = "_kd-5";
export var shortcutGroup = "_kd-3";